import Table from '@/common/components/Table'
import { Mapper } from '@/common/services/mapper'
import { establishmentPointsColumns } from '@/features/tmaisUsers/constants/establishmentPointsColumns.constant'
import { useTmaisUserEstablishmentPoints } from '@/features/tmaisUsers/hooks/useTmaisUserEstablishmentPoints'
import { EstablishmentPointsTransformer } from '@/features/tmaisUsers/services/establishmentPointsTransformer'
import { EstablishmentPointData, EstablishmentPointTableItem } from '@/features/tmaisUsers/types/tmaisUserPoints.type'
import { useState } from 'react'

interface EstablishmentPointsProps {
  userId: string
}

export default function EstablishmentPoints({ userId }: EstablishmentPointsProps) {
  const [page, setPage] = useState<number | undefined>(1)

  const {
    data: points,
    meta,
    isPending,
  } = useTmaisUserEstablishmentPoints<EstablishmentPointTableItem[]>({
    userId,
    filters: { page },
    mapper: Mapper.mapWithTransformer<EstablishmentPointData[], EstablishmentPointTableItem[]>({
      transformer: EstablishmentPointsTransformer.tableTransformer(),
    }),
  })

  return (
    <div className="flex flex-col gap-2 mt-2">
      <h2 className="font-bold">Pontos por estabelecimento</h2>

      <Table
        columns={establishmentPointsColumns}
        rows={points || []}
        emptyDataClassName="max-h-72"
        rowEmptyValue="--"
        page={page || 1}
        totalPages={meta?.total_pages || 1}
        totalCount={meta?.total}
        setPage={setPage}
        isLoadingData={isPending}
        hasPagination
      />
    </div>
  )
}
